export default __webpack_public_path__ + "2f8a1fdf1751fc42bf971fd4a75ff84b.png";